import Hero from "./Hero";
import Stats from "./Stats";
import About from "./About";
import Clients from "./Clients";
import Contact from "./Contact";

function Home() {
  return (
    <div>
      <Hero />
      <Stats />
      <About />
      <Clients />
      <Contact />
      
    </div>
  );
}

export default Home;
